<template>
  <div id="app">
    <Header v-if="!isLoginRoute"/>
    <div class="content" :class="{ 'content--auth': isLoginRoute }">
      <div class="views" :class="{ 'views--full': isLoginRoute }">
        
        <keep-alive include="FlightManager">
          <router-view ref="portalView" />
        </keep-alive>
      </div>
      <transition name="slide-fade">
        <Navigation v-if="isAuthenticated==true"/>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Header from './components/Header.vue';
import Navigation from './components/Navigation.vue';
import { routeNames } from './js/routeNames';
import { decryptData } from './js/utils/encrypt';
import { invokePortalRefresh } from './js/utils/portalHeaderRefresh';

require('./styles/main.scss');

export default {
  components: {
    Header,
    Navigation,
  },
  computed: {
    routeNames: () => { return routeNames; },
    isLoginRoute() {
      return this.$route.name === routeNames.login;
    },
  },
  data() {
    return{
      isAuthenticated : '',
      isSuperAdminConfigured: '',
      airline: [],
    };  
  },
  mounted () {
    axios.get(this.$hostName + '/isSuperAdminConfigured').then(response =>{
      this.isSuperAdminConfigured = response.data;
      this.firstCheck=false;
      localStorage.setItem('isSuperAdminConfigured', this.isSuperAdminConfigured);
    });
    
    //Decrypting isAuthenticated 
    let mkLocalData = localStorage.getItem('Login');
    let airline = localStorage.getItem('Airline');
    if(!mkLocalData){   
      mkLocalData= 'null';
    }
    if(!airline){   
      airline= 'null';
    }
    const secretKey = process.env.KEY || 'myscecretkey';
    this.isAuthenticated = decryptData(mkLocalData, secretKey);
    let airlineArray  = decryptData(airline, secretKey);
    if(airlineArray != null){
      for(let i=0; i< airlineArray.length; i++){
        this.airline.push(airlineArray[i].name);
      }
    }
    this.$root.$on('portal-header-refresh', this.onPortalHeaderRefresh);
  },
  beforeDestroy() {
    this.$root.$off('portal-header-refresh', this.onPortalHeaderRefresh);
  },
  methods: {
    onPortalHeaderRefresh() {
      const matched = this.$route.matched;
      const leaf = matched.length ? matched[matched.length - 1] : null;
      const routeVm = leaf && leaf.instances && leaf.instances.default;
      if (routeVm && typeof routeVm.refreshPortalPage === 'function') {
        routeVm.refreshPortalPage();
        return;
      }
      invokePortalRefresh(this.$refs.portalView);
    },
    goToRoute(route) {
      if(route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    }
  }
};
</script>

<style lang='scss' scoped >

#app {
  max-width: $max-width;
  max-height: $max-height;
  width: $max-width;
  height: $max-height;
  top: 0;
  left: 0;
  position: absolute;
  background-color: #fff;

  font-family: $text-font-stack;
  font-weight: 500;
  color: $general-black-light;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  overflow: hidden;

  .content {
    width: 100%;
    height: calc(100% - 72px);
    position: relative;
    float: left;

    display: flex;

    &.content--auth {
      height: 100%;
    }

    .views {
      width: calc(100% - 60px);
      height: 100%;
      position: absolute;
      top: 0;
      left: 60px;

      &.views--full {
        width: 100%;
        left: 0;
      }
    }
  }
  /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .9s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-10px);
  opacity: 0;
}
}
@import './styles/bootstrap/bootstrap.css'
</style>